module.exports = __webpack_public_path__ + "files/e3ef73b5a53b3467263f97f47eda8e4b.png";